import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";
import {
    showErrorToaster,
    showErrorToasterWithFormat,
    showSuccessToaster,
} from "store/Shared.Slice";
import { useTranslation } from "react-i18next";
import {
    useInsertAdditionalEmailMutation,
    useGetAdditionalEmailPagedListMutation,
} from "Services/OrganizationAdditionalEmailService";
import {
    handleChange,
    handleModelErrors,
    closeDialog,
} from "./OrganizationAdditionalEmail.Slice";
import FormControlWrapper from "components/FormControlWrapper";
import DialogConfirmWrapper from "components/DialogConfirmWrapper";

const OrganizationAdditionalEmailPopup = () => {
    const {
        isDialogOpen,
        newEmailAddress,
        additionalEmailListPagedData: { pageNumber, pageSize },
    } = useSelector((state) => state.organizationAdditionalEmailState);

    const dispatch = useDispatch();
    const theme = useTheme();
    const { t } = useTranslation();
    const [insertAdditionalEmail, { isLoading: isInserting }] =
        useInsertAdditionalEmailMutation();
    const [getAdditionalEmailList] = useGetAdditionalEmailPagedListMutation();

    const handleInsert = async () => {
        try {
            const response = await insertAdditionalEmail(
                newEmailAddress.value
            ).unwrap();
            await getAdditionalEmailList({ pageNumber, pageSize });

            dispatch(closeDialog());
            dispatch(showSuccessToaster(response.message));
        } catch (error) {
            // Model Errors
            if (error.data?.errors != null) {
                dispatch(showErrorToaster(t("errors.model_error")));
                dispatch(handleModelErrors(error.data?.errors));
            }

            // Bad Request
            if (error.data?.message != null) {
                dispatch(
                    showErrorToasterWithFormat({
                        message: error.data?.message,
                        format: error.data?.data,
                    })
                );
            }
        }
    };

    return (
        <DialogConfirmWrapper
            openPopup={isDialogOpen}
            titleMessage={t("labels.add_new_additional_email")}
            startIcon={<Add />}
            isLoading={isInserting}
            confirmLabel={t("buttons.add_email")}
            onConfirm={handleInsert}
            onClose={() => dispatch(closeDialog())}
            popupMessage={
                <FormControlWrapper
                    name="newEmailAddress"
                    value={newEmailAddress.value}
                    label={t("labels.new_email_address")}
                    type="email"
                    maxLength="100"
                    error={newEmailAddress.error}
                    theme={theme}
                    onChange={(element) =>
                        dispatch(
                            handleChange({
                                field: "newEmailAddress",
                                value: element.target.value,
                            })
                        )
                    }
                    required
                />
            }
        />
    );
};

export default OrganizationAdditionalEmailPopup;
